import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import {
//   LinkIcon
// } from '../../components'
import Styles from './IyvListTable.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListTdGroupCategory extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func,
    mobile: PropTypes.bool
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    return <td
      styleName='col'
      onClick={
        this.props.mobile ?
          () => { } :
          this.props.clickShareclass(this.props.shareclass)
      }
    >
      <small>
        {this.props.shareclass.category_group}
      </small>
      { /* 
        :
        <br/>
        {this.props.shareclass.morningstar_category_name}
      */ }
    </td>
  }
}